import MoveMoneyScreen from 'features/moveMoney/screens/MoveMoneyScreen';
import React from 'react';
import SubTabErrorBoundary from 'shared/patterns/wrappers/SubTabErrorBoundary/SubTabErrorBoundary';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function MoveMoneyTab() {
  return (
    <SubTabErrorBoundary>
      <PinwheelContextProvider>
        <MoveMoneyScreen />
      </PinwheelContextProvider>
    </SubTabErrorBoundary>
  );
}
